/**
 * Price-filter steps of mobile.de (EUR) — the exact values a buyer can pick in the
 * portal's price range filter. The band-axis distribution variant bins cars by these
 * steps, so a column matches what a shopper filtering by price actually sees.
 */
export const MOBILE_DE_PRICE_BANDS = [
  500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 6000, 7000, 8000, 9000, 10000, 11000,
  12000, 13000, 14000, 15000, 17500, 20000, 22500, 25000, 27500, 30000, 35000, 40000, 45000, 50000,
  55000, 60000, 70000, 80000, 90000,
];
